module.exports = "div.w3-container {\r\n    padding-top: 5px;\r\n    padding-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/salaries/salary-form/salary-form.component.css
// module id = ./src/app/components/salaries/salary-form/salary-form.component.css
// module chunks = main